import { createContext } from "react";

export const Office365GroupContext = createContext({
    groupModule: {
        refresh: true,
        isOpen: false,
        displayName: null,
        data: null,
        owners: null,
        members: null,
        mode: "read",
        visibility: null,
        searchResults: null,
        id: null
    },
    setGroupModule: () => ({})
});